import * as React from "react";
import {Button, Grid} from "react-bootstrap";
import {FormattedMessage, InjectedIntlProps, injectIntl} from "react-intl";
import {ActionBar} from "../common/ui/actionbar/ActionBar";
import {LcdIcon} from "../common/ui/icon/LcdIcon";
import {MasterDetailLayout} from "../common/ui/layouts/MasterDetailLayout";
import {FileUploadAndInjectedProps, WithFileUpload} from "../common/ui/upload/WithFileUpload";
import {WithApi, WithApiProperties} from "../common/util/WithApi";
import {AddStyleButton} from "./AddStyleButton";
import {DeleteStyleButton} from "./DeleteStyleButton";
import {StylesFilter} from "./filter/StylesFilter";
import {Style} from "./model";
import {StylesList} from "./StylesList";
import {StylesListDetailSection} from "./StylesListDetailSection";
import {StylesOutdatedWarning} from "./StylesOutdatedWarning";
import {IchStyleEditorPopup} from "./IchStyleEditorPopup";
import {StyleEditorPopup} from "../styleEditor/StyleEditorPopup"


interface StylesListState {
    selection: Style[];
    isIchStyleEditorOpen: boolean;
    isVectorStyleEditorOpen: boolean;
}

class StylesPageReactComponent extends React.Component<InjectedIntlProps & FileUploadAndInjectedProps & WithApiProperties, StylesListState> {
    constructor(props) {
        super(props);
        this.state = {
            selection: [],
            isIchStyleEditorOpen: false,
            isVectorStyleEditorOpen: false,
        };
    }

    handleRowSelect = (selectedStyles: Style[]) => {
        this.setState({selection: selectedStyles});
    }

    clearSelection = () => this.handleRowSelect([]);


    render() {
        const {selection, isIchStyleEditorOpen, isVectorStyleEditorOpen} = this.state;
        const noSelection = selection.length === 0;

        const MasterPane = (
            <Grid fluid={true}>
                <ActionBar>
                    <div>
                        <Button id={"styleFileUploadButton"}
                                bsStyle="primary"
                                className="style-data-tour-upload-button"
                                onClick={this.props.openUpload}>
                            <LcdIcon icon="upload"/>
                            <FormattedMessage id="studio.styles-page.upload-button"
                                              defaultMessage="Upload SLD"/>
                        </Button>
                    </div>
                    <AddStyleButton onAddSuccess={this.clearSelection}/>
                    <div>
                        <Button id={"styleIchButton"}
                                bsStyle="primary"
                                className="style-data-tour-upload-button"
                                onClick={this.openIchStyleEditor}>
                            <LcdIcon icon="plus"/>
                            <FormattedMessage id="studio.styles-page.ich-add-button"
                                              defaultMessage="Add Image Chain Style"/>
                        </Button>
                    </div>
                    <div>
                        <Button id={"styleVectorButton"}
                                bsStyle="primary"
                                className="style-data-tour-upload-button"
                                onClick={this.openVectorStyleEditor}>
                            <LcdIcon icon="plus"/>
                            <FormattedMessage id="studio.styles-page.vector-add-button"
                                              defaultMessage="Add Vector Style"/>
                        </Button>
                    </div>


                </ActionBar>

                <StylesFilter notifyFilterChanged={this.clearSelection}/>

                <ActionBar>
                    <DeleteStyleButton disabled={noSelection} styles={selection} onDeleteSuccess={this.clearSelection}
                                       onDeleteError={Function.prototype}
                                       onDeleteWarnings={this.clearSelection} onCloseWarnings={Function.prototype}/>
                </ActionBar>

                <div> {/* This empty div is necessary! it's used by ControlRoomTable to calculate its dimensions.*/}
                    {isIchStyleEditorOpen && <IchStyleEditorPopup onClose={this.closeIchStyleEditor}/>}
                    {isVectorStyleEditorOpen && <StyleEditorPopup onClose={this.closeVectorStyleEditor}/>}
                    <StylesList className="style-data-tour-styles-list"
                                onRowSelect={this.handleRowSelect}
                                clearSelection={noSelection}/>
                </div>
                <StylesOutdatedWarning/>
            </Grid>
        );

        const detailPane = <StylesListDetailSection selection={selection}/>;

        return (
            <MasterDetailLayout masterPane={MasterPane} detailPane={detailPane}/>
        );
    }

    private closeIchStyleEditor = () => {
        this.setState({isIchStyleEditorOpen: false});
    }

    private openIchStyleEditor = () => {
        this.setState({isIchStyleEditorOpen: true});
    }

    private openVectorStyleEditor = () => {
        this.setState({isVectorStyleEditorOpen: true});
    }

    private closeVectorStyleEditor = () => {
        this.setState({isVectorStyleEditorOpen: false});
    }


}

export const StylesPageComponent = WithFileUpload()(StylesPageReactComponent);
export const StylesPage = WithApi(injectIntl(StylesPageComponent));